import { config } from 'appConfig';
import { logPosthogException } from 'components/providers/AppPosthogProvider';

export type SeverityLevel = 'fatal' | 'error' | 'warning' | 'info' | 'debug';
export type ErrorType = 'Network Error' | 'GraphQL Error' | 'Unknown Error' | 'Fetch Exception';

export interface ScopeOptions {
  extras?: Record<string, unknown>;
  // can beused to group or filter errors in Posthog
  tags?: Record<string, string>;
  level?: SeverityLevel;
  // group similar errors together automatically in error tracking/logging systems
  fingerprint?: string[];
  type?: ErrorType | unknown;
  operationName?: string;
  query?: string | undefined;
  variables?: Record<string, unknown>;
  response?: string;
  path?: string;
  message?: string;
  stack?: string;
}

/**
 * default error logging handler.
 * handles logs to the console and to the remote logging service
 * @param error error instance to log
 * @param scopeOptions if provided, will setup a new scope with these options
 */
export function logError(error: Error, scopeOptions?: ScopeOptions): void {
  if (config.isLocalhost) {
    console.error(error);
    return;
  }

  if (!scopeOptions || !Object.keys(scopeOptions).length) {
    logPosthogException(error);
    return;
  }

  logPosthogException(error, { scopeOptions });
}
